// Drilldown API
import api, { type AxiosResponse } from './client';
import type {
  DrilldownMetricConfig,
  DrilldownDetailsResponse,
  DrilldownBreakdownResponse,
  DrilldownSummaryResponse,
  DrilldownFilters,
} from './types';

export const drilldownAPI = {
  // Get available drill-down metrics configuration
  getConfig: (): Promise<AxiosResponse<DrilldownMetricConfig[]>> =>
    api.get('/drilldown/config/'),

  // Get detailed records for a metric
  getDetails: (
    metric: string,
    params?: DrilldownFilters & { page?: number; page_size?: number; ordering?: string }
  ): Promise<AxiosResponse<DrilldownDetailsResponse>> =>
    api.get(`/drilldown/${metric}/details/`, { params }),

  // Get breakdown/grouped data for a metric
  getBreakdown: (
    metric: string,
    groupBy: string,
    filters?: DrilldownFilters
  ): Promise<AxiosResponse<DrilldownBreakdownResponse>> =>
    api.get(`/drilldown/${metric}/breakdown/`, { params: { group_by: groupBy, ...filters } }),

  // Get summary statistics for a metric
  getSummary: (
    metric: string,
    filters?: DrilldownFilters
  ): Promise<AxiosResponse<DrilldownSummaryResponse>> =>
    api.get(`/drilldown/${metric}/summary/`, { params: filters }),

  // Export drill-down data
  exportData: (
    metric: string,
    format: 'csv' | 'xlsx',
    filters?: DrilldownFilters
  ): Promise<AxiosResponse<Blob>> =>
    api.get(`/drilldown/${metric}/export/`, {
      params: { export_format: format, ...filters },
      responseType: 'blob',
    }),
};
